import { IoEyeOutline } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { selectMode } from '../../../service/slice/ThemeSlice';
import { useSelector } from "react-redux";
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import { useEffect, useState } from "react";
import Loading from "../../Loading"
import { ToastContainer, toast, } from "react-toastify";

export default function Activity() {
    DataTable.use(DT);
    const theme = useSelector(selectMode);
    const [loading, setLoading] = useState(true);
    const usertoken = localStorage.getItem('authToken')
    const [history, setHistory] = useState([])
    const navigate = useNavigate()

    const themeColor = {
        color: theme === 'light' ? '#000' : '#fff',
        background: theme === 'light' ? '#fff' : '#151A24'
    };

    const fetchMyHistory = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getSearchHistory`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${usertoken}`
            },
        });
        return response.json();
    };

    useEffect(() => {
        try {
            fetchMyHistory().then((data) => {
                if (data.status) {
                    setHistory(data.history)
                } else {
                    toast.success(data?.msg ? data?.msg : 'Something went erong please try again later.');
                }
                setLoading(false)
            })
        } catch (error) {
            setLoading(false)
            toast.error("Something went erong please try again later.");
        }
    }, [])

    function formatedTime(time) {
        const utcTime = time;
        const date1 = new Date(utcTime);
        const options = {
            timeZone: 'Asia/Kolkata',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
        };
        const input  = date1.toLocaleString('en-IN', options);
        const [datePart, timePart, meridian] = input.replace(',', '').split(' ');
        const [day, month, year] = datePart.split('/').map(Number);
        const [hours, minutes, seconds] = timePart.split(':').map(Number);

        // Convert to 24-hour format
        let hour = meridian.toLowerCase() === 'pm' && hours !== 12 ? hours + 12 : hours;
        if (meridian.toLowerCase() === 'am' && hours === 12) hour = 0;

        // Create Date object
        const date = new Date(year, month - 1, day, hour, minutes, seconds);

        // Format output
        const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        const formatted =
            `${String(date.getDate()).padStart(2, '0')} ${months[date.getMonth()]} ${date.getFullYear()} ` +
            `${String((date.getHours() % 12) || 12).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}` +
            `${date.getHours() >= 12 ? 'PM' : 'AM'}`;
        return formatted
    }

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
            {loading ?
                <Loading />
                :
                <div className="container-xxl flex-grow-1 container-p-y my-5 px-3" style={{ minHeight: "62vh" }}>
                    <div className="card shadow-sm border-0" style={themeColor}>
                        <div className="card-header d-flex justify-content-between align-items-center bg-white border-bottom-0">
                            <h5 className="card-title mb-0">Activity</h5>
                        </div>

                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-striped align-middle mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th scope="col" className="text-center">#</th>
                                            <th scope="col" className="text-center">Question</th>
                                            <th scope="col" className="text-center">Date</th>
                                            <th scope="col" className="text-center">Subject</th>
                                            <th scope="col" className="text-center">Medium</th>
                                            <th scope="col" className="text-center">Grade</th>
                                            <th scope="col" className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {history.map((data, index) => {
                                            return <tr key={index}>
                                                <td className="text-center">{index + 1}</td>
                                                <td className="text-center">
                                                    {data?.question? data?.question : 'Asked by photo or file'}
                                                </td>
                                                <td className="text-center">{formatedTime(data?.created_on)}</td>
                                                <td className="text-center">{data?.subject}</td>
                                                <td className="text-center">{data?.medium}</td>
                                                <td className="text-center">{data?.grade ? data?.grade : '6-8'}</td>
                                                <td className="text-center">
                                                    <button onClick={()=>{navigate('/user/questionview', { state: data })}} className="text-decoration-none text-primary">
                                                        <IoEyeOutline className="fs-5" />
                                                    </button>
                                                </td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
